export default {
    getterDetailsPerWorkerList: ({ list }) => list ?? [],
};
